import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;

$('.js-blog-load-more').on('click', function () {
  var $this = $(this),
    totalPages = parseInt($('[data-total-pages]').val()),
    currentPage = parseInt($('[data-current-page]').val()) + 1;
  $this.attr('disabled', true);
  var nextUrl = $('[data-next-url]')
    .val()
    .replace(/page=[0-9]+/, 'page=' + currentPage);
  $('[data-current-page]').val(currentPage);
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function (responseHTML) {
      $('.js-blog-container').append($(responseHTML).find('.js-blog-container').html());
    },
    complete: function () {
      if (currentPage < totalPages) {
        $this.attr('disabled', false);
        //  $this.find('[load-more-text]').removeClass('hide');
        //  $this.find('[loader]').addClass('hide');
      } else {
        $this.addClass('hidden');
      }
    }
  });
});
